import { UIApplication, UIApplicationDelegate, UISceneConfiguration, UISceneConnectionOptions, UIWindow } from "uikit";
import { UISceneSession } from "uikit";
import { BookingDesktopViewController } from "./scenes/BookingDesktopViewController";
import { DLDB } from "dldb";
import { MIOCoreIsPhone, MIOCoreGetPlatformLanguage, MIOCoreGetLanguages, MIOLocalizedStringsGet, MIOLocalizedStringsSet } from "mio-core";

export class AppDelegate implements UIApplicationDelegate
{
    window: UIWindow;

    dryRunCheck = true;

    applicationDidFinishLaunchingWithOptions( applicataion:UIApplication, options:any): boolean {

        DLDB.shared.options = options;

        const lang = this.setupLanguage( options );
        this.applyLocalizedStringOverrides( lang );

        let vc = new BookingDesktopViewController();
        vc.initWithNibName( MIOCoreIsPhone() ? "BookingMobileView" : "BookingDesktopView" );

        this.window = new UIWindow();
        this.window.initWithRootViewController( vc );

        return true;
    }    

    /**
     * Language: the browser language by default (UIApplication already loaded it); `?lang=es`
     * forces one of the languages declared in app.plist. The layouts are localized while they are
     * parsed, so the strings must be in place before the root view controller is created —
     * hence the synchronous load of the forced language file.
     */
    private setupLanguage ( options: any ) : string {
        const platform = MIOCoreGetPlatformLanguage();
        const forced: string = ( options?.[ "lang" ] ?? options?.[ "language" ] ?? "" ).toLowerCase().substring( 0, 2 );
        if ( forced.length == 0 || forced == platform ) return platform;

        const url = MIOCoreGetLanguages()?.[ forced ];
        if ( url == null ) return platform;

        try {
            const xhr = new XMLHttpRequest();
            xhr.open( "GET", url, false );
            xhr.send();
            if ( xhr.status == 200 ) {
                MIOLocalizedStringsSet( JSON.parse( xhr.responseText.replace( /(\r\n|\n|\r)/gm, "" ) ) );
                return forced;
            }
        }
        catch ( e ) { console.error( "Could not load language " + forced, e ); }

        return platform;
    }

    // app.plist LocalizedStrings (see DLDB.localizedStringOverrides) on top of the language file
    private applyLocalizedStringOverrides ( lang: string ) {
        const overrides = DLDB.shared.localizedStringOverrides( lang );
        if ( Object.keys( overrides ).length == 0 ) return;

        let strings = MIOLocalizedStringsGet();
        if ( strings == null ) { strings = {}; MIOLocalizedStringsSet( strings ); }
        for ( const key in overrides ) strings[ key ] = overrides[ key ];
    }

    applicationConfigurationForConnectingSceneSession( application:UIApplication, connectingSceneSession:UISceneSession, options:UISceneConnectionOptions): UISceneConfiguration {
        return new UISceneConfiguration("Default Configuration", connectingSceneSession.role);
    }

    applicationDidDiscardSceneSessions(application:UIApplication, sceneSessions:Set<UISceneSession>) {

    }
  
}